// extracted by mini-css-extract-plugin
module.exports = {"box":"PopupTemplateFour_box__33uX5","box2":"PopupTemplateFour_box2__1mYyy"};